// NekotoWan Admin API endpoint (v0.2.0 - B2B & Analytics)
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api/v1';
